import React from 'react';
import filter from 'lodash/filter';
import get from 'lodash/get';
import some from 'lodash/some';

import ExternalLink from 'src/presentation/components/pages/shared/ExternalLink';
import { isLoadingStatus } from 'src/presentation/hooks/useResource';
import TablePage, { TablePageRender } from 'src/presentation/components/pages/shared/TablePage';
import EntryPointsEditor from './EntryPointsEditor';
import useEntryPointTypes from './hooks/useEntryPointTypes';
import communicationQueuesResource from 'src/actions/communicationQueues/communicationQueuesResource';

const columnConfig = [
  { attr: 'name', label: 'Channel', sorting: true, customColumnStyle: () => ({ width: '50%' }) },
  { attr: 'inbox.name', label: 'Default Inbox', sorting: true },
  {
    attr: 'slaMinutes',
    label: 'Entry Point SLA (minutes)',
    sorting: true,
    customColumnStyle: () => ({ width: '20%' }),
  },
];

const sortingConfig = { attr: 'name' };

const EntryPoints: TablePageRender = ({ root }) => {
  const { loadingState, availableChannelTypes, errors } = useEntryPointTypes();

  const description = (
    <div data-aid="header-description">
      Manage Entry Points for all of your Channels. To learn more about Channels and Entry Points, visit our{' '}
      <ExternalLink
        data-aid="admin-entry-point-help-docs"
        label="Help Docs"
        to="https://help.gladly.com/docs/entry-points-settings-overview"
      />
      .
    </div>
  );

  return (
    <TablePage
      columnConfig={columnConfig}
      data-aid="entry-points-page"
      description={description}
      editor={EntryPointsEditor}
      emptyStateFullHeightLayout
      errors={errors}
      filterFunc={filterFunc}
      initialSorting={sortingConfig}
      isLoading={isLoadingStatus(loadingState)}
      items={availableChannelTypes}
      name="Entry Points"
      resetErrors={communicationQueuesResource.actions.resetErrors}
      root={root}
    />
  );
};

const filterFunc = (items, searchString) => {
  const searchPaths = ['name'];
  if (searchString) {
    const search = searchString.toLowerCase().trim();
    return filter(items, item =>
      some(searchPaths, columnKey => get(item, columnKey, '').toLowerCase().includes(search))
    );
  }
  return items;
};

export default EntryPoints;
